module.exports = __webpack_public_path__ + "static/media/homepage.235b4e32.aif";